// @ts-nocheck
import { Vue, Component } from 'vue-property-decorator';
import { Action, State, Mutation } from 'vuex-class';
import { canEdit } from './../utils/authUtil';
import store from './../store/index';
import Loading from './../components/loading/global';
import request from './../utils/request/index';
import apis from './../const/apis';
import { CommonObject, DraftType } from './../const/common';
import { captureError, customReport } from './../utils/errorLogger';
import * as types from './../store/types/index';
import { CampaignObjectiveValue } from './../const/state/campaign';
import { actions as MediaActions } from './../pages/media/store';

export interface LocationDraft {
  value: number[];
  country: number[];
  provice: number[];
  city: number[];
}
// TODO-kad NO_LIMIT收敛后这里的类型需要同步更正
export interface AudienceDraft {
  location: LocationDraft;
  interest: number | string[];
  carriers: number | string[];
  age: number[][];
  gender: number;
  language: number | string[];
  deviceSystem: number | string;
  deviceConnection: number | string[];
  devicePrice: number;
  specificRange: number[];
}

const namespace = 'fastCreation';

@Component({})
/**
 * 不能在组件销毁时set draft，尤其是在budget点击next时表单就提交了，后端会把draft置空，
 * 这时前端应该有个路由跳转，跳转时组件销毁又set draft了，就不对了
 */
export default class DraftMixin extends Vue {
  @State('draftType') draftType: DraftType;
  @State('routeFromFC', { namespace }) routeFromFC: boolean;
  @State((state) => state?.account?.accountInfo?.country) country: string;
  @Action('fastCreationDraft') fastCreationDraft: Function;
  @Action('verify/omitAllError') omitAllError: Function;
  @Action('creative/resetCreative') resetCreative: Function;
  @Action('audience/resetAudience') resetAudience: Function;
  @Action('budget/resetBudget') resetBudget: Function;
  @Action('verity/shouldNext') shouldNext: Function;
  @Mutation(`fastCreation/${types.SET_OBJECTIVE_TYPE}`) setObjectiveType: (
    status: CampaignObjectiveValue,
  ) => void;
  @Mutation(`verify/${types.SET_VERIFY_PROPERTY}`) setVerifyProperty: Function;

  // TODO-ABTEST billing不需要这里的逻辑
  async beforeRouteEnter(to: any, from: any, next: any): Promise<any> {
    console.log('[draftMixin beforeRouteEnter]');
    // 创编表单的错误校验路由
    try {
      await store?.dispatch?.('verify/shouldNext', { from, to });
      next?.();
    } catch (e) {
      Loading?.hide?.();
    }
  }

  async mounted(): Promise<any> {
    if (!canEdit()) {
      this.showNoAuthority();
    }
    // todo-kad 创编提交之后要removeEventListener
  }

  beforeUnLoadHandler(event: any): void {
    this.updateDraft();
    event.returnValue = '';
  }

  // 提示没有权限
  showNoAuthority(): void {
    const options = {
      message: this.$t('common_account_no_authority'),
      confirmButtonText: 'Confirm',
    };
    Vue.$alert('Content', options).then(() => {
      // this.handleAccountListRefresh()
      // this.accountSelectVisible = true
      this.$router.push({
        name: 'perf-dashboard-detail',
        query: { ...this.$route.query },
      });
    });
  }

  /**
   * 草稿提示是否回传
   */
  async handleDraft(autoConfirm = false): Promise<any> {
    try {
      window.onbeforeunload = this.beforeUnLoadHandler;
      const { data = {} } = await this.getDraft();
      const { has_draft = false, draft_json = {} } = data;
      if (!has_draft) {
        return;
      }
      if (!autoConfirm) {
        await this.$confirm(this.$t('module_fastcreation_draft_hint'), {
          cancelButtonText: this.$t('module_fastcreation_draft_startover'),
          confirmButtonText: this.$t('module_fastcreation_draft_continue'),
        });
      }
      // confirm
      this.resetDraft(draft_json);
    } catch (e) {
      // startover
      this.updateDraft({});
      customReport.counter('customError', e);
    }
  }

  // 创编草稿保存
  async updateDraft(data?: unknown): Promise<void> {
    if (this.draftType === DraftType.none) {
      return;
    }

    let draftJson;
    if (!!data) {
      draftJson = data;
    } else if (this.draftType === DraftType.fastcreation) {
      draftJson = await this.fastCreationDraft();
    } else {
      return;
    }

    try {
      await request.post(
        apis.adgroup.set_draft,
        {
          draft_json: draftJson,
        },
        {
          params: {
            draft_type: this.draftType,
          },
          shouldRetry(data: { code: number }) {
            return data.code !== 0;
          },
        },
      );
      return;
    } catch (e) {
      customReport.counter('customError', e);
    }
  }

  // 创编草稿获取
  getDraft(): Promise<any> {
    return request.get(apis.adgroup.get_draft, {
      draft_type: this.draftType,
    });
  }
  /**
   * 草稿置值或置空
   */
  resetDraft(data: CommonObject<{}>): void {
    try {
      if (this.draftType === DraftType.fastcreation) {
        const { objective = {}, audience = {}, creative = {}, budget = {}, media = {} } = data;
        const { objective_type } = objective;
        this.omitAllError(); // 去掉所有的校验信息
        if (objective_type) {
          this.setObjectiveType(objective_type);
        } else if (Object.keys(creative).length && !objective_type) {
          // 存量的traffic 草稿
          this.setObjectiveType(CampaignObjectiveValue.Traffic);
        } else {
          this.setObjectiveType(CampaignObjectiveValue.NotSelected);
        }

        MediaActions.setMediaDraft(media);
        this.resetCreative({
          ...creative,
          externalUrl: objective?.external_url || creative?.externalUrl || '', // 兼容存量草稿
        });
        this.resetAudience(audience);
        this.resetBudget(budget);
      }
    } catch (e) {
      captureError(e);
    }
  }
}
